module.exports = __webpack_public_path__ + "static/img/dq8.0507826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq8.png
// module id = zzdm
// module chunks = 0